/**
 * What is Citizen Web's own on the shared account screens (@tonnie/account):
 * its brand panel, its language picker, and where a finished sign-in or
 * sign-up goes — a satellite's `redirect_url` (the Clerk handshake back to
 * Business Web), else the dashboard. Mounted once in App.tsx.
 */
import type { AccountPortalConfig } from '@tonnie/account';
import { TONNIE_LEGAL_URLS } from '@tonnie/foundation';

import { LanguageSelector } from '@/components/ui/LanguageSelector';
import { featureFlags } from '@/core/config/feature-flags';

import { readPostAuthRedirect } from './utils/post-auth-redirect';

export const CITIZEN_ACCOUNT_PORTAL: AccountPortalConfig = {
  portal: 'citizen',
  languageSelector: <LanguageSelector showLabel />,
  afterSignIn: () => readPostAuthRedirect() ?? '/dashboard',
  afterSignUp: () => readPostAuthRedirect() ?? '/dashboard',
  legal: TONNIE_LEGAL_URLS,
  securitySettingsPath: '/settings?tab=security',
  allowTotp: featureFlags.ENABLE_2FA,
};
